import React from 'react';
import { Box, Container, Typography, Grid, alpha } from '@mui/material';
import { Event, GroupAdd, Videocam } from '@mui/icons-material';

export default function VideoMeetingSteps() {
  const steps = [
    {
      icon: <Event />,
      title: 'Toplantı Oluşturun',
      desc: 'Yönetim panelinden yeni bir video konferans oluşturun. Toplantı tarihini ve saatini belirleyerek planlama yapın.',
      color: '#ec4899'
    },
    {
      icon: <GroupAdd />,
      title: 'Katılımcıları Davet Edin',
      desc: 'Toplantıya katılacak üyeleri belirleyin ve davet bağlantılarını SMS, e-posta veya bildirim ile gönderin.',
      color: '#8b5cf6'
    },
    {
      icon: <Videocam />,
      title: 'Toplantıyı Başlatın',
      desc: 'Toplantı zamanı geldiğinde video konferansı başlatın ve katılımcılar bağlantıya tıklayarak kolayca katılsın.',
      color: '#0891b2'
    }
  ];

  return (
    <Box sx={{ py: { xs: 8, md: 12 }, background:'#f8fafc'}}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
                variant="h3"
                sx={{
                  fontWeight: 800,
                  mb: 3,
                  color: '#0f172a',
                  fontSize: { xs: '1.9rem', md: '2.4rem' }
                }}
          >
            Nasıl Çalışır?
          </Typography>
          <Typography
               sx={{
                  fontSize: '1.05rem',
                  color: '#475569',
                  lineHeight: 1.8,
                  mb: 4,
                }}
          >
            3 basit adımda video konferans başlatın
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {steps.map((step, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Box
                sx={{
                  position: 'relative',
                  p: 5,
                  height: '100%',
                  borderRadius: 4,
                  background: 'white',
                  border: '1px solid #e5e7eb',
                  textAlign: 'center',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    boxShadow: `0 8px 32px ${alpha(step.color, 0.12)}`,
                    borderColor: alpha(step.color, 0.3),
                    transform: 'translateY(-4px)',
                  },
                }}
              >
                {/* Step Number */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: -16,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    background: `linear-gradient(135deg, ${step.color} 0%, ${alpha(step.color, 0.7)} 100%)`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontWeight: 900,
                    fontSize: '1.25rem',
                    boxShadow: `0 4px 16px ${alpha(step.color, 0.3)}`,
                  }}
                >
                  {index + 1}
                </Box>

                {/* Icon */}
                <Box
                  sx={{
                    width: 72,
                    height: 72,
                    borderRadius: 3,
                    background: `linear-gradient(135deg, ${alpha(step.color, 0.1)} 0%, ${alpha(
                      step.color,
                      0.05
                    )} 100%)`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto',
                    mb: 3,
                    mt: 2,
                    color: step.color,
                    '& svg': { fontSize: 36 },
                  }}
                >
                  {step.icon}
                </Box>

                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: '1.25rem',
                    mb: 2,
                    color: '#1e293b',
                  }}
                >
                  {step.title}
                </Typography>

                <Typography
                  sx={{
                    color: '#64748b',
                    lineHeight: 1.7,
                    fontSize: '0.95rem',
                  }}
                >
                  {step.desc}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}